export const QUESTION_IMAGE_IDENTIFIER = 'questionImage';
//# sourceMappingURL=types.js.map